import Accordion from '../components/Accordion';

export default class DynamicFaq {
  constructor(section) {
    this._initAccordion(section);
  }

  _initAccordion(section) {
    const el = section.el.querySelector('[data-faq-block]');
    const tabletEl = section.el.querySelector('[data-faq-tablet-block]');

    if (!el) {
      return;
    }

    new Accordion({
      el: el,
      triggerClass: 'faq-trigger',
      contentClass: 'faq-content',
      closeOnClickOutside: false,
    });

    if (!tabletEl) {
      return;
    }

    new Accordion({
      el: tabletEl,
      triggerClass: 'faq-trigger',
      contentClass: 'faq-content',
      closeOnClickOutside: false,
    });
  }
}
